import React, { useState } from "react";
// imoprt Email
import Email from "../assets/img/common/email.png";

const CtaArea = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [succeeded, setSucceeded] = useState(false);
  const [emailValue, setEmailValue] = useState("");
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await fetch(
        "https://email-nodejs-fawn.vercel.app/api/send-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            emailConfig: {
              host: "mail.nascentinnovations.com",
              port: 465,
              user: "polani@nascentinnovations.com",
              pass: "TestZain123",
              from: "Polani Team <polani@nascentinnovations.com>",
            },
            emailData: {
              to: "herezainali@gmail.com",
              subject: "Newsletter Subscription from House of Polani",
              text: `New subscription from: ${emailValue}`,
              html: `<p>New subscription from: ${emailValue}</p>`,
            },
          }),
        }
      );

      if (response.ok) {
        setSucceeded(true);
        setEmailValue("");
      } else {
        const errorData = await response.json();
        setError(errorData.message || "Failed to subscribe. Please try again.");
      }
    } catch (err) {
      setError("Network error. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section id="cta_area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="cta_left">
                <div className="cta_icon">
                  <img src={Email} alt="icon" />
                </div>
                <div className="cta_content">
                  <h4>Get the latest news and offers</h4>
                  <h2>Subscribe to our newsletter</h2>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="cat_form">
                <form
                  onSubmit={handleSubmit}
                  id="tour_bookking_form_item"
                  className=""
                >
                  <div className="input-group">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter your mail address"
                      name="email"
                      value={emailValue}
                      onChange={(e) => setEmailValue(e.target.value)}
                      required
                    />
                    <button
                      type="submit"
                      className="btn btn_theme btn_md"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "Subscribe"}
                    </button>
                  </div>
                  {error && (
                    <div className="col-lg-12">
                      <div className="vendor_form_heading">
                        <p className="text-danger mt-2">{error}</p>
                      </div>
                    </div>
                  )}
                  {succeeded && (
                    <div className="col-lg-12">
                      <div className="vendor_form_heading">
                        <h5 className="mt-2">
                          Thank You! Subscribe Successfully
                        </h5>
                      </div>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CtaArea;
